import graphql__2a6e083778e79c730da9 from "./__generated__/searchFormFieldOptionsQuery.graphql.js";import { fetchQuery, graphql } from "react-relay";

import appRelayEnvironment from "../../config/AppRelayEnvironment";

// Delay before searching what is being typed, so that a search is not sent for every
// keystroke. Shared by every select searching the options of a field.
export const SEARCH_DEBOUNCE_TIMEOUT = 250;

// Loads a page of the options matching what the contributor types. The "Other" option
// comes with the first page, so it stays one step away rather than behind every page of
// a long list.
export const searchFormFieldOptions = async ({
  formFieldId,
  terms,
  cursor,
  otherField
}) => {
  const { formFieldOptionsSearch } = await fetchQuery(
    appRelayEnvironment,
    searchFormFieldOptionsQuery,
    { formFieldId, terms, after: cursor },
    { fetchPolicy: "network-only" }
  ).toPromise();

  const { edges, pageInfo } = formFieldOptionsSearch;
  const foundOptions = edges.map(({ node: { id, name } }) => ({
    value: id,
    label: name
  }));

  const firstPageOptions = otherField && !cursor ? [otherField] : [];

  return {
    options: [...firstPageOptions, ...foundOptions],
    hasMore: pageInfo.hasNextPage,
    additional: { cursor: pageInfo.endCursor }
  };
};

const searchFormFieldOptionsQuery = graphql__2a6e083778e79c730da9;
